export default "https://cdn-static.gokick.com/assets/96917af4b324ebd1ae50a0309f8a33967fe87b4d/images/one-pack.d480e98fa5cc774d464fa35a18a8809f.png";